import type { ReactNode } from 'react'

interface Props {
  /** 統計以前の理由で数字が信用できない状態か。 */
  blocked: boolean
  /** 伏せている理由。品質の指摘の見出しをそのまま並べる。 */
  reasons: readonly string[]
  children: ReactNode
}

/**
 * 判定を見せる前の関門。
 *
 * 警告の直下に色のついた判定カードを並べても、読み飛ばされるのは警告のほうで、
 * 持ち出されるのは「有意に改善」と効果量だけになる。このツールが止めたい誤読は
 * まさにそれなので、データが壊れているときは判定を既定で伏せ、開く操作を挟んで
 * 「これは結論ではない」と宣言してから見せる。
 *
 * 数字そのものは消さない。隠しきると、手元で計算し直した数字だけが
 * 警告の届かない形で独り歩きして、同じ誤読が別の場所で起きる。
 */
export function ResultGuard({ blocked, reasons, children }: Props) {
  if (!blocked) return <>{children}</>

  return (
    <section className="blocked">
      <div className="blocked-head">
        <span className="blocked-icon" aria-hidden="true">
          ⛔
        </span>
        <div>
          <h2 className="blocked-title">この結果は判定に使えません</h2>
          <p className="blocked-detail">
            {reasons.join(' / ')}
            のため、統計以前にデータが壊れています。この状態の p 値や効果量は、
            どちらの案を採るかの根拠になりません。原因を直して測り直してください。
          </p>
        </div>
      </div>
      <details className="blocked-details">
        <summary className="blocked-summary">
          それでも計算結果を見る（結論としては使えません）
        </summary>
        <div className="blocked-body">{children}</div>
      </details>
    </section>
  )
}
